module.exports = __webpack_public_path__ + "f43bd8d9a7b125f45510fb87903cd72c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-2.jpg
// module id = 391
// module chunks = 0